export const LOGIN = 'login/SignInModal';
export const SIGN_UP = 'login/SignUpModal';
export const FORGET_PASSWORD = 'login/ForgetPasswordModal';
export const PROFILE = 'login/ProfileModal';
export const RESET_PASSWORD = 'login/ResetPasswordModal';
export const SAVE_CONFIRMATION = 'login/SaveConfirmationModal';
